import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import NearMeIcon from '@mui/icons-material/NearMe';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';

const item: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 5,
};

function ProductValues() {
  return (
    <Box
      component="section"
      sx={{ display: 'flex', overflow: 'hidden', bgcolor: 'secondary.light' }}
    >
      <Container sx={{ mt: 15, mb: 30, display: 'flex', position: 'relative' }}>
        <Box
          component="img"
          src="/static/themes/onepirate/productCurvyLines.png"
          alt="curvy lines"
          sx={{ pointerEvents: 'none', position: 'absolute', top: -180 }}
        />
        <Grid container spacing={0} direction="column" justifyContent="space-between" alignItems="center">
          <Grid container spacing={3}>
            <Box sx={{ flex: 2, marginLeft: 2 }} textAlign='center'>
              <Typography variant="h1" align="center" sx={{ my: 5, fontSize: 30 }}>
                About our Service <br /> <br />
              </Typography>
            </Box>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Typography>
                  <NotificationImportantIcon color="primary" sx={{ fontSize: 40 }} />
                </Typography>
                <Typography variant="h6" sx={{ my: 5 }}>
                  我々の課題感
                </Typography>
                <Typography variant="h5">
                  英語の「音」の多くは、日本語話者にとって馴染みのあるものではないのに、「英語が持つ全ての音」の体系的な学習はなされていません。<br /><br />
                  例えば、大量のシャドーイングやリスニングを通じて「膨大な音」を聞くことが、日本人にとって効率的な学習につながるとは考えていません。
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Typography>
                  <TaskAltIcon color="primary" sx={{ fontSize: 40 }} />
                </Typography>
                <Typography variant="h6" sx={{ my: 5 }}>
                  解決の方向性
                </Typography>
                <Typography variant="h5">
                  日本人は「ひらがな」の各々の音を幼少期に学んでいます。その際、各々の音の聞き分けを学ぶわけです。当然、英語ネイティブも同様に英語の音の聞き分けを学んでいます。<br /><br />
                  そこで我々は、幼少期に英語圏で過ごすような状態を仮想的かつ効率的に作りたいと考えたのです。

                  <br />
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={item}>
                <Typography>
                  <NearMeIcon color="primary" sx={{ fontSize: 40 }} />
                </Typography>
                <Typography variant="h6" sx={{ my: 5 }}>
                  早期の「音素学習」を提案
                </Typography>
                <Typography variant="h5">
                  我々は「なるべく早期」の「音素学習」によって、人工的に帰国子女のような脳の状態をつくり出すことが可能だという仮説を持ち、サービス開発に取り組みました。<br /><br />
                  サイエンスの進展に基づく、全く新しい英語学習法「音素学習」を広めることが我々のミッションです。
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box >
  );
}

export default ProductValues;
